import React from 'react'
import Popper from '@material-ui/core/Popper';
import FilterPopup from './FilterPopup';
import FilterPopupReport from './FilterPopupReport';
import FilterPopupTrafficRegulation from './FilterPopupTrafficRegulation';
import GetfacilityTypeData from './MyMapUtils/GetfacilityTypeData';
import GetManagementStatus from './MyMapUtils/GetManagementStatus';


function SearchFilter(props) {

    const anchorRef = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const handleClick = (event) => {
        if(props.isMobileMode){
            props.updateShowFiltersInfo({ type: "filterKind", value: props.filterKind });
            props.updateShowFiltersInfo({ type: "filterKind_str", value: props.filterKind_str });
            props.updateShowFiltersInfo({ type: "filterKind_end", value: props.filterKind_end });
            props.updateShowFiltersInfo({ type: "popupKind", value: props.popupKind });
            props.updateShowFiltersInfo({ type: "masterKind", value: props.masterKind });
            props.updateShowFiltersInfo({ type: "isFacilityType", value: props.isFacilityType });
            props.updateShowFiltersInfo({ type: "targetTypes", value: props.targetTypes });
            props.updateShowFiltersInfo({ type: "DateTime_str", value: props.DateTime_str });
            props.updateShowFiltersInfo({ type: "DateTime_end", value: props.DateTime_end });
            props.updateShowFiltersInfo({ type: "label", value: props.label });
            props.updateShowFiltersInfo({ type: "targetType", value: props.targetType });
            props.onClick();
        }else{
            setOpen(true);
        }
    };
   
    function onApplyFilter(checkedTypes){
        props.onApplyFilter(props.filterKind, checkedTypes);
    }
    
    function onClose(){
        setOpen(false);
    }
    function getStyle() {
        return {
            background: props.isDisabled ? "#eee" : null,
            display: props.isShow ? null:"none"
        };
    }
    function getClassName() {

        switch(props.filterKind){
            case('report'):
                //住民通報のフィルタが設定されているか
                if(props.filters.reportStatus.length > 0
                    || props.filters.reportDate_str !== "" || props.filters.reportDate_end !== "")
                    return " searchfilter-button-highlight";
                break;
            case('trafficregulation'):
                //通行制限のフィルタが設定されているか
                if(props.filters.applicationStatus.length > 0
                    || props.filters.applicationDate_str !== ""|| props.filters.applicationDate_end !== ""
                    || props.filters.restrictedDateTime_str !== ""|| props.filters.restrictedDateTime_end !== "")
                    return " searchfilter-button-highlight";
                break;
            default:
                //デフォルト（対象など）のフィルタが設定されているか
                if(props.targetTypes?.length > 0)
                    return " searchfilter-button-highlight";

                //日付のフィルタが設定されているか
                if(props.DateTime_str || props.DateTime_end)
                    return " searchfilter-button-highlight";

                //ラジオは常に選択されている
                if(props.targetType?.length > 0)
                    return " searchfilter-button-highlight";
                break;
        }
        return "";
    }
   
    return (
        <div className="">

        <div ref={anchorRef} className="" />

            <button
                className={"searchfilter-button" + (getClassName())}
                style={getStyle()}
                onClick={handleClick}
                disabled={props.isDisabled}>

                {props.popupKind === "list" ?
                    props.targetTypes && props.targetTypes.length > 0 ?
                        props.isFacilityType? 
                            props.targetTypes.map(type =>
                                <img key={type} src={GetfacilityTypeData(type,"icon")} className="facility-icon" alt="" />)
                        :
                        props.masterKind?
                            <span>{props.targetTypes.map(x=>GetManagementStatus(props.masterKind,x,"name")).join("、")}</span>
                        :
                            <span>{props.targetTypes.join("、")}</span>
                    :
                    <span>{props.label}</span>
                :   
                props.popupKind === "date" ?
                    props.DateTime_str || props.DateTime_end ?
                        <span>{props.DateTime_str} ～ {props.DateTime_end}</span>
                    :
                        <span>{props.label}</span>
                :
                props.popupKind === "radio" ?
                    <span>{props.label}</span>
                :
                <span>{props.label}</span>    
                }
                <div className="searchfilter-down"><i className="bi bi-caret-down-fill"></i></div>
            </button>
            <Popper open={open} anchorEl={anchorRef.current} placement={'bottom-start'} transition style={{ zIndex: 10000 }}>

                {/* ポップで表示する内容の切替 */}
                {(() => {
                switch(props.filterKind) {
                    //住民通報
                    case('report'): {
                        return (
                            <FilterPopupReport
                                userAuthorities={props.userAuthorities}
                                keyword={props.keyword}
                                isFacilityType={props.isFacilityType}
                                filterKind={props.filterKind}
                                targetTypes={props.targetTypes}
                                filters={props.filters}
                                onApplyFilter={onApplyFilter}
                                onApplyFilter_date={props.onApplyFilter_date}
                                onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                                onSearch={props.onSearch}
                                onClose={onClose}

                                width={props.width}
                                height={props.height}
                                anchorRef={anchorRef}
                                updateShowFiltersInfo={props.updateShowFiltersInfo}
                                isMobileMode={props.isMobileMode}
                                onClick={props.onSearchFilterClick}
                                
                                viewtype={props.viewtype}
                            />
                        )
                    }
                    //通行制限
                    case('trafficregulation'): {
                        return (
                            <FilterPopupTrafficRegulation
                                userAuthorities={props.userAuthorities}
                                keyword={props.keyword}
                                isFacilityType={props.isFacilityType}
                                filterKind={props.filterKind}
                                targetTypes={props.targetTypes}
                                filters={props.filters}
                                onApplyFilter={onApplyFilter}
                                onApplyFilter_date={props.onApplyFilter_date}
                                onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                                onSearch={props.onSearch}
                                onClose={onClose}

                                width={props.width}
                                height={props.height}
                                anchorRef={anchorRef}
                                updateShowFiltersInfo={props.updateShowFiltersInfo}
                                isMobileMode={props.isMobileMode}
                                onClick={props.onSearchFilterClick}
                                
                                viewtype={props.viewtype}
                            />
                        )
                    }
                    //写真撮影日orその他
                    default:
                    case('filmingDateTime'):{
                        return (
                            <FilterPopup
                                userAuthorities={props.userAuthorities}
                                keyword={props.keyword}
                                filters={props.filters}
                                onApplyFilter={onApplyFilter}
                                onApplyFilter_date={props.onApplyFilter_date}
                                onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                                onClose={onClose}
                                
                                viewtype={props.viewtype}

                                isFacilityType={props.isFacilityType}
                                masterKind={props.masterKind}
                                popupKind={props.popupKind}
                                filterKind={props.filterKind}
                                filterKind_str={props.filterKind_str}
                                filterKind_end={props.filterKind_end}
                                targetTypes={props.targetTypes}
                                DateTime_str={props.DateTime_str}
                                DateTime_end={props.DateTime_end}
                                targetType={props.targetType}
                            />
                        )
                    }
                    }
                })()}
            </Popper>
        </div>

    );

}

export default SearchFilter;
